
/**
 * CSV Writer Class
 */
export class CSVWriter {
  constructor() {
    
    this.exportHeaders = false
    this.columnList = []
    this.rows = []
  }


  /**
   * Add a column
   */
  addColumn(name, field) {
    this.columnList.push({
      name: name,
      field: field
    })
  }


  /**
   * Add a row
   */
  addRow(rowData) {
    this.rows.push(rowData)
  }


  /**
   * Export the data to a CSV string
   */
  export() {
    var newlineDelimeter = '\n'
    var fieldDelimeter = ','

    var outputLines = ''
    if(this.exportHeaders)
      outputLines += this.columnList.map(columnInfo => this.escapeData(columnInfo.name)).join(fieldDelimeter) + newlineDelimeter

    this.rows.forEach(row => {
      let rowData = []

      this.columnList.forEach(columnInfo => {
        rowData.push(this.escapeData(row[columnInfo.field] || ''))
      })

      outputLines += rowData.join(fieldDelimeter) + newlineDelimeter
    })
    
    return outputLines
  }


  escapeData(value) {
    // If a string, add quotes
    if(_.isString(value)) {
      return JSON.stringify(value)
    }
    return value
  }

}